import React, { useEffect, useMemo, useState } from 'react';

import { graphql } from 'gatsby';
import Moment from 'moment';

import BlogCard from '../components/Blog/BlogCard';
import Footer from '../components/Footer';
import GatsbyPagination from '../components/GatsbyPagination';
import Seo from '../components/Seo';
import Header from '../components/navbar/Header';
import MobileNav from '../components/navbar/MobileNav';
import { useMixpanel } from '../functions/Mixpanel';

import * as style from './blog.module.css';

const Blog = ({ data, pageContext }) => {
  const skip = pageContext.skip;
  const total = data.allContentfulBlog.totalCount;
  const currentPage = pageContext.currentPage;

  const { mixpanel } = useMixpanel();
  const posts = data.allContentfulBlog.edges;
  const placeHolder =
    data.allFile.edges[0].node.childImageSharp.gatsbyImageData;

  useEffect(() => {
    mixpanel.track('View Page', { 'Page Name': 'Web Blog' });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const [postsPerPage] = useState(15);

  const numPages = Math.ceil(data.allContentfulBlog.totalCount / postsPerPage);

  const pagesNumbers = useMemo(() => {
    const Numbers = [];
    for (let i = 1; i <= numPages; i++) {
      Numbers.push(i);
    }
    return Numbers;
  }, [numPages]);

  return (
    <div>
      <Header
        pageName="Blog Page"
        pageCategory="patient"
        link="https://apps.apple.com/app/apple-store/id6446295104?pt=123955580&ct=Web%20Blog&mt=8"
      />
      <MobileNav
        buttonTitle="Download app"
        link="https://apps.apple.com/app/apple-store/id6446295104?pt=123955580&ct=Web%20Blog&mt=8"
        openInNewTab
      />
      <Seo
        title="Fertility and IVF Blog | Alife"
        description="Your guide to understanding IVF from start to finish"
        siteUrl="https://www.alifehealth.com/blog/"
      />
      <div>
        <div className={style.blogHeroSection}>
          <h1>Alife Blog</h1>
          <h3>Your guide in understanding IVF from start to finish</h3>
        </div>
        <div className={style.blogPostContainer}>
          <div className={style.blogContentContainer}>
            <div className={style.LGridbox}>
              {posts.map((post, index) => {
                const title = post.node.title;

                const link = post.node.slug;
                const image =
                  post.node.image !== null
                    ? post.node.image.gatsbyImageData
                    : placeHolder;
                const date = post.node.createdAt;
                return (
                  <BlogCard
                    key={index}
                    title={title}
                    link={link}
                    img={image}
                    clicked={() => {
                      mixpanel.track('Open Article', {
                        'Article Title': title,
                      });
                    }}
                    date={Moment(date).format('MMMM, YYYY')}
                  />
                );
              })}
            </div>
            <div className={style.articleCount}>
              <p className="subTitle">
                ({skip ? skip : 1}-
                {skip
                  ? skip * currentPage > total
                    ? total
                    : skip * currentPage
                  : 15}
                /{total})
              </p>
              <div className={style.pageNumbersContainer}>
                <GatsbyPagination
                  totalPages={pagesNumbers}
                  currentPage={currentPage ? currentPage : 1}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer pageName="Web Blo" />
    </div>
  );
};

export default Blog;

export const query = graphql`
  query LearnQuery($limit: Int! = 15, $skip: Int! = 0) {
    allContentfulBlog(limit: $limit, skip: $skip, sort: { createdAt: DESC }) {
      totalCount
      edges {
        node {
          slug
          title
          createdAt(formatString: "D MMMM YYYY")
          updatedAt(formatString: "D MMMM YYYY")
          summary {
            summary
            childMarkdownRemark {
              htmlAst
            }
          }
          fullBlogPost {
            childMarkdownRemark {
              htmlAst
            }
          }
          image {
            gatsbyImageData
            file {
              url
            }
          }
        }
      }
    }

    allFile(
      filter: {
        extension: { regex: "/(jpg)|(png)|(jpeg)/" }
        relativeDirectory: { eq: "blog" }
      }
    ) {
      edges {
        node {
          id
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
          }
          base
        }
      }
    }
  }
`;
